export default "__VITE_ASSET__BrH6A7JU__"